import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http'; 
import { HttpModule } from '@angular/http';
import { tap } from 'rxjs/operators/tap';
import { IUserProfile, IViewUserModel, INewUser} from '../interfaces/';
import { UserProfile, NewUser, ViewUserModel} from '../models/';
import { PwrDetails } from '../models/PwrDetails';

const url = "http://api.reptilebin.com/api/auth";
//const url = "http://localhost:53148//api/auth";
const httpOptions = {
	headers: new HttpHeaders({
		'Content-Type': 'application/json',
		'Access-Control-Allow-Origin':'*',
		'Access-Control-Allow-Methods': 'HEAD, GET, POST, PUT, PATCH, DELETE',
		'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token'
	})
};

@Injectable()
export class AuthServiceService {

  user: INewUser = new NewUser();
  localProfile: IUserProfile = new UserProfile();
  viewUserModel: IViewUserModel = new ViewUserModel();
  constructor(public http: HttpClient) {}

  resetUser (){
  	this.user.Id = 0;
  	this.user.Password = '';
  	this.user.Token = '';
  	this.user.UserName = '';
  	this.user.UserSalt = '';
  	this.user.IsActive = false;
  	this.user.IsDeleted = false;
  	this.user.ProfileId = 0;	
  }

  login(userDetails: NewUser):Observable<INewUser>{
		this.resetUser();
		return this.http.post<INewUser>(url+"/GetUser", userDetails, httpOptions).pipe(
			tap(resp => {
				Object.assign(this.user, resp);	
				this.setToken(this.user.Token, this.user.UserName, this.user.ProfileId);		
		}));
  	}

  	createUser(userDetail: NewUser, userProfile: IUserProfile):Observable<INewUser>{
		this.resetUser();
		this.viewUserModel = new ViewUserModel();
		this.viewUserModel.user = userDetail;
		this.viewUserModel.profile = userProfile;
		return this.http.post<NewUser>(url+"/CreateUser", this.viewUserModel, httpOptions).pipe(
			tap(resp => {
				Object.assign(this.user, resp);
				this.setToken(this.user.Token, this.user.UserName, this.user.ProfileId);
		}));
  	}

  	getUserProfile(profileId: number):Observable<IUserProfile>{
		return this.http.post<UserProfile>(url+"/GetUserProfile", profileId, httpOptions).pipe(
			tap(resp => {
				this.localProfile = resp;
				let groupId = JSON.stringify({GroupId: resp.GroupId});									
				let roleId = JSON.stringify({RoleId: resp.RoleId});									
				sessionStorage.setItem("groupId", groupId);
				sessionStorage.setItem("roleId", roleId);
				return resp;
			}));
  	}

  	setToken(_token, _userName, _profileId){
		let userInfo = JSON.stringify({Token: _token, userName:_userName, profileId: _profileId });
		sessionStorage.setItem("token", userInfo);
  	}

  	CheckTempIdExpiration(TempId: string):Observable<any>{
  		let temp = JSON.stringify(TempId);
		return this.http.post<any>(url+"/CheckTempIdExpiration", temp, httpOptions).pipe(
			tap(resp => {
				return resp;
			}));
  	}

  	ResetPassword(details: PwrDetails):Observable<any>{
  		let temp = JSON.stringify(details);
  		return this.http.post<any>(url+"/ResetPassword", temp, httpOptions).pipe(
			tap(resp => {
				return resp;
			}));	
  	}

  	PasswordResetRequest(userName: string):Observable<any>{
  		let temp = JSON.stringify(userName);
  		return this.http.post<any>(url+"/PasswordResetRequest", temp, httpOptions).pipe(
			tap(resp => {
				return resp;
			}));
  	}

  	UsernameRequest(email: string):Observable<string>{
  		let temp = JSON.stringify(email);
  		return this.http.post<string>(url+"/UsernameRequest", temp, httpOptions).pipe(
			tap(resp => {
				return resp;
			}));
  	}

  	UpdateProfile(profile: IUserProfile):Observable<any>{
  		return this.http.post<any>(url+"/UpdateProfile", profile, httpOptions).pipe(
			tap(resp => {
				return resp;
			}));	
  	}

  	ResetPasswordFromAccount(details: PwrDetails):Observable<any>{
  		return this.http.post<any>(url+"/ResetPasswordFromAccount", details, httpOptions).pipe(
			tap(resp => {
				return resp;
			}));		
  	}
}



// WEBPACK FOOTER //
// ./src/app/services/auth-service.service.ts